//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
//------------------------------------------------------ funciones
import Button from "../../buttons/Button";
import FormMovimientoTrafico from "../../formularios/events/FormMovimientoTrafico";

const MovimientoTraficoAccess = ({ type = "trafico", title = "EVENTO" }) => {
  const [formVisible, setFormVisible] = useState(false);

  const handleOpen = () => {
    setFormVisible(true);
  };

  const handleClose = () => {
    setFormVisible(false);
  };

  return (
    <>
      <Button text={title} onClick={handleOpen} icono="satelital" />

      {formVisible && (
        <FormMovimientoTrafico
          type={type}
          onGuardar={handleClose}
          onClose={handleClose}
          plus={true}
        />
      )}
    </>
  );
};

export default MovimientoTraficoAccess;
